<template>
  <div class="user-admin ml-4 mr-4" >
      <b-form>
          <input id="user-id"  type="hidden" v-model="user.id" />
          <b-row>

                <b-col sm="2">
             
                  <b-form-group label="Registro :" label-for="user-email">
                      <b-form-input id="user-email" type="text"
                        v-model="user.email" required
                        @keyup.enter="loadFuncionario()"
                        :readonly="mode === 'remove'"
                        placeholder="Registro do funcionário" />
                  </b-form-group>
              </b-col>


              <b-col sm="5">                
                  <b-form-group label="Nome:" label-for="user-name">
                      <b-form-input id="user-name" type="text"
                        v-model="user.name" required
                        :readonly="mode === 'remove'"
                        placeholder="Informe o Nome do Usuário..." />
                  </b-form-group>
              </b-col>

            <b-col sm="4">
              <label for="input-parecer">Grupo de usuário</label> 
              <div>                    
                <b-form-select   id="grupo"               
                  v-model="user.id_grupo"  
                  :options="tpgrupos"
                  class="mb-3"
                  text-field="grupo"                            
                >                
                </b-form-select>
              </div>
            </b-col>

            <b-form-checkbox class="mt-5" id="user-admin" v-show="mode === 'save'"
            v-model="user.admin">
              Administrador?
          </b-form-checkbox>
              


          </b-row>

          <b-row v-show="mode ==='save'">
              <b-col>
                  <b-form-group label="Senha:" label-for="user-password">
                      <b-form-input id="user-password" type="password"
                        v-model="user.password" required
                        placeholder="Informe a Senha do Usuário..." />
                  </b-form-group>
              </b-col>
                <b-col>
                    <b-form-group label="Confirmação de Senha:"
                  label-for="user-confirm-password">
                      <b-form-input id="user-confirm-password" type="password"
                        v-model="user.confirmPassword" required
                        placeholder="Confirme a Senha do Usuário..." />
                  </b-form-group>
              </b-col>
          </b-row>


          <b-row>
                <b-col xs="12">
                    <b-button size="sm" variant="primary" class="mr-2" v-if="mode === 'save'"
                        @click="save">Salvar</b-button>
                    <b-button size="sm" variant="danger" v-if="mode === 'remove'"
                        @click="remove">Excluir</b-button>
                    <b-button size="sm" @click="reset">Cancelar</b-button>                
              </b-col>
          </b-row>
    </b-form>
    <hr>
    <b-table small hover striped sticky-header="440px" :items="users" :fields="fields">                            
        <template slot="cell(actions)" slot-scope="data">
            <b-button size="sm" variant="warning" @click="loadUser(data.item)" class="mr-2">
                <i class="fa fa-pencil"></i>
            </b-button>
            <b-button size="sm" variant="danger" @click="loadUser(data.item, 'remove')">
                <i class="fa fa-trash"></i>
            </b-button>
        </template>
    </b-table>      
    </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

 



export default {
    name: 'UserAdmin',
    data: function() {
        return {
            mode: 'save',
            user: {},
            users: [],
            tpgrupos:[],
            viacep:[],
            iporigem:[],

            
            fields: [
                { key: 'id', label: 'Código', sortable: true },
                { key: 'id_funcionario_erp', label: 'Id_Erp', sortable: true },
                { key: 'grupo', label: 'Grupo', sortable: true },
                { key: 'name', label: 'Nome', sortable: true },
                { key: 'email', label: 'Registro', sortable: true },                                
                { key: 'admin', label: 'Administrador', sortable: true,formatter: value => value ? 'Sim' : 'Não' },
                { key: 'dt_cadastro', label: 'Data de cadastro', sortable: true }, 
                { key: 'actions', label: 'Ações' }
            ]
        }        
    },
    methods: {
        loadUsers() {
            const url = `${baseApiUrl}/users`
            axios.get(url).then(res => {
                this.users = res.data
               // console.log(this.users);                
            })
        },
        reset() {
            this.mode = 'save'
            this.user = {}
            this.loadUsers()
        },
        save() {
            const method = this.user.id ? 'put' : 'post'
            const id = this.user.id ? `/${this.user.id}` : ''
            axios[method](`${baseApiUrl}/users${id}`, this.user)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },
        remove() {
            const id = this.user.id
            axios.delete(`${baseApiUrl}/users/${id}`)
                .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                })
                .catch(showError)
        },

        loadUser(user, mode = 'save') {
            this.mode = mode
            this.user = { ...user }
            this.loadGrupo()
        },

        ////////////////////////////////

        loadFuncionario() {            
          const url = `${baseApiUrl}/users/funcionario/${this.user.email}`
           axios.get(url).then(res => { this.user = res.data })                    
        }, 

        loadCep() {      
            axios.get('https://viacep.com.br/ws/08081320/json/').then(res => { this.viacep = res.data })
        }, 
        
         loadIpOrigem() {      
            axios.get('https://ipinfo.io/json').then(res => { this.iporigem = res.data })
        },        

        loadGrupo() {
          const url = `${baseApiUrl}/users/grupo`
          axios.post(url).then(res => {
            this.tpgrupos = res.data.map(tpl => {              
               return { ... tpl, value: tpl.id_grupo, grupo: tpl.grupo }
            })
          })
        },
    },
    mounted() {
        this.loadUsers()
        this.loadGrupo()  
       // this.loadCep()
        this.loadIpOrigem()
     //   this.loadFuncionario()              
     
    },
    
}
</script>

<style>

.table{
    font-size: 0.7em;
}

</style>
